import classNames from 'classnames'
import useRenderEvent from '@/core/hooks/useRenderEvent'

import { ReactComponent as ThreeDotsIcon } from '@/assets/icons/three-dots-icon.svg'

import './FixedLabelsButtons.scoped.sass'

function FixedLabelButton ({ label, selectedLabel, selectLabel, labelPadding }) {
  return <li
    id={'label-button' + label.name}
    style={{ 'padding-top': labelPadding, 'padding-bottom': labelPadding }}
    className={classNames({ active: selectedLabel === label.name })} onClick={() => selectLabel(label)}>
    <div className="label-left">
      <span className='label-icon'>
        <ThreeDotsIcon />
      </span>
      {label.name}
    </div>
  </li>
}

export function FixedLabelsButtons ({ selectedLabel, selectLabel, labelPadding }) {
  useRenderEvent(['LABELS:UPDATED'])
  const fixedLabels = [
    {
      name: 'All',
      filterName: 'all',
      filterValue: 'all',
      hasChildBoxes: false,
    }
  ]
  return fixedLabels.map((fixedLabel) => {
    return <FixedLabelButton key={fixedLabel.name} labelPadding={labelPadding} label={fixedLabel} selectedLabel={selectedLabel} selectLabel={selectLabel} />
  })
}
